<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15uwNKF/tc-custom/9781459263314.jpg?1722625962583" alt="This image is the cover for the book Sweet Betrayal"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sweet Betrayal
      </h1>
      <p class="bookDescription body article font2">
        <b>A woman hoping to avenge her family falls in love with her handsome enemy in this sexy international romance.</b><br/><br/><i>Once bitten, twice shy . . .</i><br/><br/>Nothing could fade the bitter memories Candy had of Cameron Strythe. How could he have been so callous, abandoning her pregnant sister all those years ago? He’d disrupted their lives, and he was still disturbing Candy’s peace of mind with his dynamic presence and all too charming manner.<br/><br/>But this man had betrayed her sister and, Candy vowed, it was her absolute duty to exact a full and meaningful revenge—at any cost!<br/><br/>“Helen Brooks pens a superb story with rich characters, sparkling interplay and a riveting emotional conflict.” —<i>Romantic Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen Brooks
      </h2>
      
      <p class="authorDescription body article">Helen Brooks began writing in 1990 as she approached her 40th birthday! She realized her two teenage ambitions (writing a novel and learning to drive) had been lost amid babies and hectic family life, so set about resurrecting them. In her spare time she enjoys sitting in her wonderfully therapeutic, rambling old garden in the sun with a glass of red wine (under the guise of resting while thinking of course). Helen lives in Northampton, England with her husband and family.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8dbbc0fc